import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Swal from "sweetalert2";
import { env } from "../../../env";
import axios from "axios";

const EventCancelModal = ({ eventDetails, setShowCancelViewModal, cancelReasonList, sendEventChildFromData }) => {
    const { t } = useTranslation();
    const dropdownRef = useRef(null);
    const [isLoad, setIsLoad] = useState(false);
    const [showDropDown, setShowDropDown] = useState();
    const [inputs, setInputs] = useState({
        id: 0,
        reasonId: "",
        reasonName: "",
        comment: "",
    });

    useEffect(() => {
        setInputs((prev) => ({
            ...prev,
            id: eventDetails.id,
        }));
    }, [eventDetails]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropDown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleShowCancelModal = (e) => {
        e.preventDefault();
        setShowCancelViewModal()
    };
    const handleDropDown = (e, data) => {
        e.preventDefault();
        setInputs((prev) => ({
            ...prev,
            reasonId: data.ID,
            reasonName: data.Title
        }));
        setShowDropDown(false)
    };
    const handleChange = (e) => {
        setInputs((prev) => ({
            ...prev,
            comment: e.target.value
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        Swal.fire({
            title: `${ t("are you sure")}?`,
            text: `${ t("you want to cancel this appointment")}?`,
            width: 400,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {  
                setIsLoad(true);
                const baseUrl = env.REACT_APP_API_URL;
                const token = localStorage.getItem('token');    
                const requestData = {
                    "appointmentid": inputs.id,
                    "cancel_reason_id": inputs.reasonId,
                    "cancel_comments": inputs.comment
                };
                console.log(requestData);

                axios.post(baseUrl+`/api/ClientAppointments/CancelClientAppointment`, requestData, {
                    headers : {
                        "Accept" : "Application/json",
                        "Content-Type" : "Application/json",
                        "Authorization" : `Bearer ${token}`
                    }
                }).then((response) => {
                    console.log(response);
                    if(response.data.success === "1") {
                        sendEventChildFromData("cancel");
                    }
                }).catch((error) => {
                    console.log(error);
                    setIsLoad(false);
                    if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("userInfo");
                        window.location.reload();
                    }
                });
            }
        });
    };

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-end sm:items-center z-50">
            <form onSubmit={handleSubmit}>
                <div className="bg-white rounded-t-lg sm:rounded-lg shadow-lg w-[28rem] p-2.5 sm:p-6 space-y-2 sm:space-y-4">
                    <div className="flex justify-between items-center">
                        <div className='flex items-center space-x-2'>
                            <h3 className="text-lg font-semibold capitalize">
                                { t('cancel appointment')}
                            </h3>
                        </div>
                        <button type="button" onClick={(e) => (!isLoad && handleShowCancelModal(e))} className="text-gray-500 hover:text-gray-700">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
                            </svg>
                        </button>
                    </div>
                    <div className="space-y-2">
                        <div className="text-sm sm:text-base">
                            {moment(eventDetails.start).format('ddd')} | {moment(eventDetails.start).format('LL')} at {moment(eventDetails.start).format('LT')} - {moment(eventDetails.end).format('LT')}
                        </div>
                        <div className="sm:flex sm:items-center text-sm space-y-1 sm:space-y-0">
                            <div className="sm:border sm:border-y-2 sm:border-l-2 sm:border-background-normal sm:p-2 sm:bg-blue-light capitalize sm:rounded-l-lg sm:w-40 sm:text-center">{ t('reason')}</div>
                                <div ref={dropdownRef} className="relative border border-l-2 sm:border-l-0 border-y-2 border-r-2 border-background-normal p-2 w-full rounded-l-lg sm:rounded-l-none rounded-r-lg">
                                    <button type="button" onClick={(e) => setShowDropDown(!showDropDown)} className=" text-gray-dark w-full justify-between font-normal inline-flex items-center">
                                        <span className={(inputs.reasonName ? "text-black" : "text-gray-dark") + " capitalize mr-1 text-sm"}>{inputs.reasonName ? inputs.reasonName : t('select reason')}</span>
                                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                    </button>
                                    {
                                        showDropDown
                                        ? 
                                            <ul className="absolute z-30 bg-white shadow-md rounded-md top-10 right-0 w-full">
                                                {cancelReasonList.map((reason, index) => (
                                                    <li key={`reason${index}`} onClick={(e) => handleDropDown(e, reason)}  className="bg-white hover:bg-action-hover py-1 sm:py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-sm">{ t(reason.Title)}</li>
                                                ))}
                                            </ul>                            
                                        : null
                                    }
                                </div>
                            </div>
                        <textarea value={inputs.comment} onChange={handleChange} className="bg-white border-2 border-background-normal rounded-md px-4 py-2 w-full relative flex items-start focus:outline-none" rows={5} columns={10} placeholder={ t("write comments here...")}></textarea>
                    </div>
                    <div className="flex justify-between items-center text-sm sm:text-base">
                        <button type="button" onClick={(e) => (!isLoad && handleShowCancelModal(e))} className="px-4 py-2 bg-white text-gray-dark4 capitalize font-medium border-2 border-background-normal rounded-lg">
                            { t('close')}
                        </button>
                        <button type={isLoad ? "button" : "submit"} className={(isLoad ? "cursor-not-allowed" : "cursor-pointer") + " px-4 py-2 bg-blue-normal text-white rounded-lg capitalize"}>
                            {isLoad ? (t('Please wait')+'...') : t('cancel appointment')}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default EventCancelModal;
